import { ModulesManagerService } from "../../Module/modules-manager.service";

export class ApisAdmin {
    private id = 0
    private society = ""
    private internalName = ""
    private link = ""
    private projectOwnerEmail = ""
    private basedOnToken = true
    private activate = false
    private isSynced = false
    private credits = 0
    private expireDate = 0
    private type = 0
    private secureCode = ""
    private useEmailService = true
    constructor(private manager: ModulesManagerService) { }

    get Id() {
        return this.id
    }

    get Link() {
        return this.link
    }

    set Link(value) {
        this.link = value
    }

    get Activate() {
        return this.activate
    }

    set Activate(value) {
        this.activate = value
    }

    get IsSynced() {
        return this.isSynced
    }

    set IsSynced(value) {
        this.isSynced = value
    }

    get Type() {
        return this.type
    }

    set Type(value) {
        this.type = value
    }

    get Credits() {
        return this.credits
    }

    set Credits(value) {
        this.credits = value
    }

    get InternalName() {
        return this.internalName
    }

    set InternalName(value) {
        this.internalName = value
    }

    get Society() {
        return this.society
    }

    set Society(value) {
        this.society = value
    }

    get ProjectOwnerEmail() {
        return this.projectOwnerEmail
    }

    set ProjectOwnerEmail(value) {
        this.projectOwnerEmail = value
    }

    get BasedOnToken() {
        return this.basedOnToken
    }

    set BasedOnToken(value) {
        this.basedOnToken = value
    }


    get ExpireDate() {
        return (new Date(this.expireDate))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_DATETIME_PICKER"))
    }

    set ExpireDate(value) {
        this.expireDate = (new Date(value)).getTime()
    }

    get SecureCode() {
        return this.secureCode
    }

    set SecureCode(value) {
        this.secureCode = value
    }

    get UseEmailService() {
        return this.useEmailService
    }

    set UseEmailService(value) {
        this.useEmailService = value
    }

    containValue(value) {
        let str_enabled = this.manager.Trad.Parse("STR_ENABLED")
        let str_disabled = this.manager.Trad.Parse("STR_DISABLED")
        let str_api_in = this.manager.Trad.Parse("STR_API_IN")
        let str_api_out = this.manager.Trad.Parse("STR_API_OUT")
        let compare = ""
        let containers = ["Society", "InternalName", "Link", "Activate", "Type", "Credits"];
        for (let container of containers) {
            switch (container) {
                case "Activate":
                    compare = this[container] ? str_enabled : str_disabled
                    if (compare.toLowerCase().includes(value.toLowerCase())) return true
                    break
                case "Type":
                    compare = this[container] == 1 ? str_api_in : str_api_out
                    if (compare.toLowerCase().includes(value.toLowerCase())) return true
                    break
                default:
                    if (this[container].toString().toLowerCase().includes(value.toLowerCase())) return true
            }
        }


        return false
    }

    navigateTo() {
        this.manager.Navi.navigateTo('admin/api/', { id: this.id })
    }

    hydrate(data) {
        for (let [k, v] of Object.entries(data)) {
            switch (k) {
                case "Activate":
                case "IsSynced":
                case "BasedOnToken":
                    v = 1 == v
                    break
            }
            this[this.manager.Tool.minimilizeFirstChar(k)] = v
        }

    }

    export() {
        return {
            Id: this.id,
            Link: this.link,
            InternalName: this.internalName.toLowerCase(),
            Society: this.society.toLowerCase(),
            Credits: this.credits,
            Type: this.type,
            Activate: this.activate,
            SecureCode: this.secureCode,
            ProjectOwnerEmail: this.projectOwnerEmail,
            BasedOnToken: this.basedOnToken,
            ExpireDate: this.expireDate,
            UseEmailService: this.useEmailService
        }
    }
}
